<template>
  <section>
    <log-double-slider-selector
      v-if="includedSlider === 'log double'"
      ref="logDoubleSlider"
      v-bind:percentOfHandsInRangeNumberForDisplay="percentOfHandsInRangeNumberForDisplay"
      v-bind:numberOfSpecificHandsInRange="numberOfSpecificHandsInRange"
      v-bind:numberOfPossibleSpecificHands="numberOfPossibleSpecificHands"
      v-bind:disabled="disabled"
      v-on:setRangeToMatchDoubleSlider="$emit('setRangeToMatchDoubleSlider', $event)"
    />
    <double-slider-selector
      v-if="includedSlider === 'double'"
      ref="doubleSlider"
      v-bind:percentOfHandsInRangeNumberForDisplay="percentOfHandsInRangeNumberForDisplay"
      v-bind:numberOfSpecificHandsInRange="numberOfSpecificHandsInRange"
      v-bind:numberOfPossibleSpecificHands="numberOfPossibleSpecificHands"
      v-bind:disabled="disabled"
      v-on:setRangeToMatchDoubleSlider="$emit('setRangeToMatchDoubleSlider', $event)"
    />
    <single-slider-selector
      v-if="includedSlider === 'single'"
      v-bind:percentOfHandsInRangeNumberForDisplay="percentOfHandsInRangeNumberForDisplay"
      v-bind:disabled="disabled"
      v-on:setRangeToMatchDoubleSlider="$emit('setRangeToMatchDoubleSlider', $event)"
    />
  </section>
</template>

<script>
import LogDoubleSliderSelector from '@/components/hand-range/slider-selector/log-double-slider-selector';
import DoubleSliderSelector from '@/components/hand-range/slider-selector/double-slider-selector';
import SingleSliderSelector from '@/components/hand-range/slider-selector/single-slider-selector';

export default {
  name: 'slider-selector',
  components: {
    'log-double-slider-selector': LogDoubleSliderSelector,
    'double-slider-selector': DoubleSliderSelector,
    'single-slider-selector': SingleSliderSelector,
  },
  props: ['percentOfHandsInRangeNumberForDisplay', 'numberOfSpecificHandsInRange', 'numberOfPossibleSpecificHands', 'disabled'],
  computed: {
    includedSlider: function () {
      return this.$store.state.account.user.settings.general.includedSelectors.slider;
    },
  },
  methods: {
    resetDoubleSlider: function () {
      if (this.includedSlider === 'log double') {
        this.$refs.logDoubleSlider.reset();
      } else if (this.includedSlider === 'double') {
        this.$refs.doubleSlider.reset();
      }
    },
    refreshDoubleSlider: function () {
      if (this.includedSlider === 'log double') {
        this.$refs.logDoubleSlider.refresh();
      } else if (this.includedSlider === 'double') {
        this.$refs.doubleSlider.refresh();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/hand-range/slider-selector/slider-selector.vue